export const SET_AUDIT_LOGS = "SET_AUDIT_LOGS";
export const SET_AUDIT_FILTERS = "SET_AUDIT_FILTERS";
